import request from '@/plugins/request';

// 采购单 =====================================================================
// 采购订单列表
export function apiPurchaseOrderList(data) {
    return request({
        url: `/purchase/order/list`,
        method: 'post',
        data,
    });
}

// 采购订单导出
export function apiPurchaseOrderExport(data) {
    return request({
        url: `/purchase/order/export/list`,
        method: 'post',
        data,
    });
}

// 品牌商列表
export function apiBrandingCompanyList(data) {
    return request({
        url: `/purchase/order/branding/company/list`,
        method: 'get',
        params: data,
    });
}

// 品牌商列表-实时
export function apiBrandingCompanyRealtimeList(data) {
    return request({
        url: `/purchase/order/branding/company/list/real/time`,
        method: 'get',
        params: data,
    });
}

// 采购单详情
export function apiPurchaseOrderDetail(data) {
    return request({
        url: `/purchase/order/get`,
        method: 'get',
        params: data,
    });
}

// 新增采购单
export function apiPurchaseOrderSave(data) {
    return request({
        url: `/purchase/order/save`,
        method: 'post',
        data,
    });
}

// 收货地址列表
export function apiPurchaseAddressList(data) {
    return request({
        url: `/address/list`,
        method: 'post',
        data,
    });
}

// 新增收货地址
export function apiPurchaseAddressSave(data) {
    return request({
        url: `/address/save`,
        method: 'post',
        data,
    });
}

// 设置默认地址
export function apiPurchaseAddressSetDefault(data) {
    return request({
        url: `/address/set/default/address`,
        method: 'put',
        params: data,
    });
}

// 删除地址
export function apiPurchaseAddressRemove(data) {
    return request({
        url: `/address/remove`,
        method: 'delete',
        params: data,
    });
}

// 全国省市区
export function apiGaodeTree(data) {
    return request({
        url: `/gaode/all/tree`,
        method: 'get',
        params: data,
    });
}

// 选择商品
export function apiPurchaseOrderSelectProduct(data) {
    return request({
        url: `/purchase/order/select/product`,
        method: 'post',
        data,
    });
}

// 商品详情
export function apiPurchaseOrderProductDetail(data) {
    return request({
        url: `/purchase/order/product/detail`,
        method: 'get',
        params: data,
    });
}

// 非轮订单 =====================================================================
// 订单列表
export function apiNonwheelOrderList(data) {
    return request({
        url: `/brand/order/findPage`,
        method: 'post',
        params: data,
    });
}

// 订单导出
export function apiNonwheelOrderExport(data) {
    return request({
        url: `/brand/order/export`,
        method: 'post',
        params: data,
    });
}

// 发货
export function apiOrderSendProduct(data) {
    return request({
        url: '/brand/order/sendProduct',
        method: 'post',
        params: data,
    });
}

// 退款单列表
export function apiListRefundOrder(orderId) {
    return request({
        url: `/brand/order/refundOrder/${orderId}`,
        method: 'get',
    });
}

// 非轮订单退款step1-查询订单详情和退货情况
export function apiRefundStep1(data) {
    return request({
        url: `/brand/refund/order/step1`,
        method: 'get',
        params: data,
    });
}

// 非轮订单退款step2-计算退款金额明细
export function apiRefundStep2(data) {
    return request({
        url: `/brand/refund/order/step2`,
        method: 'post',
        data,
    });
}

// 非轮订单退款step3-确认退款
export function apiRefundStep3(data) {
    return request({
        url: `/brand/refund/order/step3`,
        method: 'post',
        data,
    });
}

// 批量发货模板下载
export function apiBatchLoginfoTemplate(data) {
    return request({
        url: `/brand/order/downloadTemplate`,
        method: 'post',
        data,
    });
}

// 批量发货物流导入
export function apiBatchLoginfoImportFile(data) {
    return request({
        url: `/brand/order/batchImportLoginfo`,
        method: 'post',
        data,
    });
}

// 查看物流
export function apiOrderLogisticsInfo(orderId) {
    return request({
        url: `/brand/order/getExpInfo/${orderId}`,
        method: 'get',
    });
}
